<template>
    <div>
        <div @click="$emit('closesubinfo')" class="savewithsub"></div>
        <div class="submodal">
            <h5>{{ $root.language.wsm_sub_info_popup_head }}</h5>
            <span v-html="$root.language.wsm_sub_info_popup_body"></span>
            <div class="btnContainer">
                <button @click="$emit('closesubinfo')">{{ $root.language.wsm_sub_closePopup }}</button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    methods: {
        see(e) {
            console.log(e)
        }
    }
}
</script>

<style lang="scss" scoped>
.savewithsub {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.309);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 1000;


}

h5 {
    font-size: 2rem;
    margin-bottom: 1rem;
}

.submodal {
    position: fixed;
    width: auto;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1000;
    max-width: 704px;
    padding: 2rem;
    background: white;
    transform: translateY(20vh);
    height: auto;
    border-radius: 10px;
    box-shadow: -1px 3px 19px 13px #00000017;

    .btnContainer {
        width: 100%;
        display: flex;
        margin-top: 1.5rem;

        button {
            background: #2e4145;
            color: white;
            border: 0;
            padding: 0.7rem 1.5rem 0.7rem 1.5rem;
            font-weight: bold;
            margin: 0 auto;
            cursor: pointer;

            &:hover {
                background: #3d555a;
            }
        }
    }

}</style>